import { createSlice } from "@reduxjs/toolkit";

import { fetchPipelineByOwnerRanked } from "./actions";

const PAGE_SIZE = 25;

const DEFAULT_ERROR = "Failed to load ranked pipeline by owner";

const pipelineByOwnerRankedSlice = createSlice({
  name: "pipelineByOwnerRanked",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
    offset: 0,
    pageSize: PAGE_SIZE,
  },
  reducers: {
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    resetPagination: (state) => {
      state.offset = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPipelineByOwnerRanked.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPipelineByOwnerRanked.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchPipelineByOwnerRanked.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export const { setOffset, resetPagination } = pipelineByOwnerRankedSlice.actions;
export default pipelineByOwnerRankedSlice.reducer;
